// extracted by mini-css-extract-plugin
module.exports = {"Time":"time-module--Time--25p-B","Hours":"time-module--Hours--2ngtf","Icon":"time-module--Icon--1T5jI"};